/**
 * Amire VAN fordításunk.
 *
 * Egy helyen: a fejléc nyelvváltója ebből épül, és a belépéskor visszaolvasott, mentett
 * felhasználói nyelvet is ehhez mérjük. Enélkül két lista volna ugyanarról, és egy új
 * nyelv bevezetésekor az egyiket el lehetne felejteni — a felület akkor olyan nyelvre
 * váltana, amin nincs mit megjelenítenie.
 */
export const SUPPORTED_LOCALES = Object.freeze(['hu', 'en']);

export default SUPPORTED_LOCALES;
